import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../../../services/auth.service';
import {Customer} from '../../../models/CustomerInfo/Customer';
import {RegistryService} from '../../../services/registry.service';
import {CustomerAddress} from '../../../models/CustomerInfo/CustomerAddress';
import {CartService} from '../../../services/cart.service';
import {ShippingMethod} from '../../../models/CartModels/Checkout/ShippingMethod';
import {GoogleAnalyticsService} from '../../../services/google-analytics.service';
import {Cart} from '../../../models/CartModels/cart';
import {response} from 'express';

@Component({
    selector: 'app-shipping-methods',
    templateUrl: './shipping-methods.component.html',
    styleUrls: ['./shipping-methods.component.css']
})
export class ShippingMethodsComponent implements OnInit, OnDestroy {


    status = null;
    selectedMethod: ShippingMethod = new ShippingMethod();
    showAll = true;
    cart: Cart;

    shippingMethods: ShippingMethod[] = [];
    customer: Customer;
    subTotal = 0;
    userLoggedEvent;
    shippingAddressUpdatedEvent;
    cartUpdatedEvent;
    discountCode;


    constructor(private authService: AuthService,
                private googleService: GoogleAnalyticsService,
                public registry: RegistryService, private cartService: CartService) {

        this.cartUpdatedEvent = cartService.CartChangedEvent$.subscribe(cart => {

            this.cart = cart;




            this.subTotal = 0;

            for (let i = 0; i < this.cart.items.length; i++) {
                const newPrice = Math.round(((this.cart.items[i].price * this.cart.items[i].qty) + Number.EPSILON) * 100) / 100;
                this.subTotal += newPrice;

            }
            if (this.subTotal < 5) {
                this.reset();
            }



        });

        this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });


        this.cartService.ShippingAddressUpdatedEvent$.subscribe(address => {

            this.loadShippingMethods(address);
            // this.showAll = false;

        });


        this.cartService.ShippingMethodUpdatedEvent$.subscribe(method => {
            this.googleService.eventEmitter('shipping_method_selected', 'checkout', 'shipping_method_selected', method.method_code);

            if (this.selectedMethod.method_code != method.method_code) {
                this.selectedMethod = method;

                this.showAll = false;
            }

        });

    }

    ngOnInit(): void {

        this.discountCode = localStorage.getItem('discount_code');

    }

    loadShippingMethods(address: CustomerAddress) {
        this.cartService.loadShippingMethods(address).subscribe(result => {

            this.shippingMethods = result;
            if (result.length == 1) {
                this.setMethodSelected(result[0]);
            }

        });
    }

    showAllShippingMethods(event) {
        event.preventDefault();


        this.showAll = true;

    }

    setMethodSelected(method: ShippingMethod) {

        if (method.method_code != this.selectedMethod.method_code) {
            this.selectedMethod = method;
            this.cartService.selectedShippingMethod = method;
            this.cartService.EmitShippingMethodUpdated(method);
            if (this.discountCode) {
                this.cartService.applyCartCode(this.discountCode).subscribe(response => {
                    if(response){
                        this.cartService.checkCartReady();

                    }

                });
            }




        } else if (this.subTotal > 5 ) {

        } else {
            this.selectedMethod = new ShippingMethod();
            this.cartService.selectedShippingMethod = null;
        }

        this.cartService.checkCartReady();
        this.cartService.checkOrderReady();


    }

    ngOnDestroy(): void {

        if (this.shippingAddressUpdatedEvent) {
            this.shippingAddressUpdatedEvent.unsubscribe();
        }
        if (this.userLoggedEvent) {
            this.userLoggedEvent.unsubscribe();
        }
        if (this.cartUpdatedEvent) {
            this.cartUpdatedEvent.unsubscribe();
        }
    }

    reset() {
        this.shippingMethods = [];
    }

}
